module.exports = __webpack_public_path__ + "static/img/3.b35aaca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R404A/3.jpg
// module id = Uhk4
// module chunks = 1